import { Component } from '@angular/core';
import { BaseInlineUpdateComponent, InlineContainerService } from 'yt-ng-framework';
import { EPrijemnicaOpasnaMaterija } from './eprijemnica-opasna-materija';

@Component({
  selector: 'yt-eprijemnica-opasna-materija-inline-update',
  templateUrl: './eprijemnica-opasna-materija-inline-update.component.html'
})
export class EPrijemnicaOpasnaMaterijaInlineUpdateComponent
  extends BaseInlineUpdateComponent<EPrijemnicaOpasnaMaterija> {

  constructor(protected inlineContainerService: InlineContainerService<EPrijemnicaOpasnaMaterija>) {
    super(inlineContainerService);
  }
}
